<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex xs12 sm10 offset-sm1 md10 offset-md1 lg8 offset-lg2>
          <v-card row class="mt-3 mb-4">
            <v-card-title primary-title class="white" raised>
              <h3 class="headline mb-0">LokalesHandwerk.de Premium Mitgliedschaft</h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p class="my-5 subheading">Die Mitgliedschaft kostet
                <strong>25,00€ netto im Monat</strong>(inkl. 19% MwSt.
                <strong>29,75€ brutto im Monat</strong>). Es fallen keine weiteren Kosten an.
              </p>
              <h2 class="subheading">Ihre Vorteile:</h2>
              <v-list class="my-3">
                <v-list-tile>- Zusätzliche individuelle Suchbegriffe möglich</v-list-tile>
                <v-list-tile>- Bessere Platzierung in der Standard-Suche</v-list-tile>
                <v-list-tile>- Umfangreicheres Profil auf LokalesHandwerk.de mit Möglichkeit Medien zu verwenden</v-list-tile>
                <v-list-tile>- Sie unterstützen LokalesHandwerk.de und damit das organisierte Handwerk im Internet</v-list-tile>
              </v-list>
              <div v-if="stripeid">
                <h3 class="subheading">Hinterlegte Daten:</h3>
                <br>
                <p class="">
                  Gewählter Zeitraum: {{ stripeid.subscriptions.data[0].plan.nickname }}
                  <br>
                  Name: {{ stripeid.sources.data[0].owner.name }}
                  <br>
                  E-Mail: {{ stripeid.sources.data[0].owner.email }}
                  <br>
                  Mandatsreferenz: {{ stripeid.sources.data[0].sepa_debit.mandate_reference }}
                  <br>SEPA-Lastschriftmandat:
                  <a
                    :href="`${stripeid.sources.data[0].sepa_debit.mandate_url}`"
                    target="_blank"
                  >Link zu Ihrem SEPA-Lastschriftmandat</a>
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {

  metaInfo () {
    return { title: 'Premium Infos' }
  },
  data () {
    return {
      stripeloading: true,
      stripevorhanden: false,
      stripesource: '',
      stripeid: ''

    }
  },
  mounted: function () {
    axios
      .get('/api/v1/stripeid')
      .then(response => {
        this.stripeid = response.data

        this.stripeloading = false

        if (typeof this.stripeid.sources !== 'undefined') {
          if (this.stripeid.sources.data.length > 0) {
            this.stripesource = true
          }
        }
      })
        .catch(error => {
          console.log(error)
        })
  },
  methods: {

  }
}

</script>


